import { useCallback, useMemo, useState } from 'react'

import { Filter } from '@cubejs-client/core'
import { type CubeReportPageFiltersType } from 'cube/contexts/cubeReportPageFilters.context'

/**
 * Hook that manages reports page-level cube filters.
 * @returns { pageFilters, onChangePageFilters }
 */
const useCubeReportPageFilters = (): CubeReportPageFiltersType => {
  const [filters, setFilters] = useState<Filter[]>([])

  const onChangePageFilters = useCallback((filters: Filter[]) => {
    setFilters(filters)
  }, [])

  return useMemo(
    () => ({
      pageFilters: filters,
      onChangePageFilters,
    }),
    [filters, onChangePageFilters]
  )
}

export default useCubeReportPageFilters
